import { LogLevel } from './LogLevel';
import { logger } from './Logger';
import * as typeUtils from '../misc/typeUtils';
var maxValueStringLength = 30;
function stringifyValue(value) {
    if (typeUtils.isUndefined(value))
        return "undefined";
    if (value == null)
        return "null";
    if (typeUtils.isString(value)) {
        var str = value.toString();
        if (str.length > maxValueStringLength) {
            str = str.substring(0, maxValueStringLength - 3) + '...';
        }
        return "'" + str + "'";
    }
    if (typeUtils.isNumber(value) || typeUtils.isBoolean(value))
        return value.toString();
    if (typeUtils.isFunction(value)) {
        var functionName = typeUtils.getTypeName(value);
        var str = 'function';
        if (functionName) {
            str = str + " " + functionName;
        }
        return str;
    }
    return "object " + typeUtils.getTypeName(value);
}
function stringifyArgs(args) {
    if (args == null)
        return '';
    return args.map(function (v) { return stringifyValue(v); }).join(', ');
}
export function Trace(logLevel, errorLogLevel) {
    if (logLevel === void 0) { logLevel = LogLevel.Trace; }
    if (errorLogLevel === void 0) { errorLogLevel = LogLevel.Error; }
    return function (target, propertyKey, descriptor) {
        if ((logger.enabledFor(logLevel) || logger.enabledFor(errorLogLevel)) && typeUtils.isFunction(descriptor.value)) {
            var oldFunc_1 = descriptor.value;
            descriptor.value = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var functionString = typeUtils.getTypeName(this) + "." + propertyKey + "(" + stringifyArgs(args) + ")";
                logger.log(logLevel, "Executing " + functionString, {
                    this: this,
                    args: args
                });
                var result;
                try {
                    result = oldFunc_1.apply(this, args);
                }
                catch (e) {
                    logger.log(errorLogLevel, "Failed " + functionString, {
                        this: this,
                        args: args,
                        exception: e
                    });
                    throw e;
                }
                if (!typeUtils.isUndefined(result)) {
                    Promise.resolve(result).then(function (r) {
                        logger.log(logLevel, "Executed " + functionString + " = " + stringifyValue(r), {
                            this: _this,
                            args: args,
                            result: r
                        });
                    }, function (r) {
                        logger.log(errorLogLevel, "Failed " + functionString, {
                            this: _this,
                            args: args,
                            reason: r
                        });
                        return Promise.reject(r);
                    });
                }
                return result;
            };
        }
    };
}
//# sourceMappingURL=Trace.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/logging/Trace.js
// module id = 13
// module chunks = 1